import { Model, type ModelProps } from '@/infra/model'
import { observable, computed } from 'mobx'
import { unixEpoch } from '@/utils/date-util'
import { addDays } from 'date-fns'
import { asAtom, toStream } from '@/utils/mobx-util'
import { switchMap } from 'rxjs/operators'
import { countdown } from '@/utils/rx-util'
import { Id } from '@/infra/id'

export type WorkspaceInvitationProps = ModelProps<WorkspaceInvitation>

/**
 * An invitation to apply to a workspace posting.
 */
export class WorkspaceInvitation extends Model<WorkspaceInvitation> {
  /**
   * An observable countdown. Ticks every second in sync with clock time until
   * the scheduled expiration time is reached.
   */
  private readonly _timeUntilExpiration$ = toStream(
    () => this.dateExpires,
    true,
  ).pipe(switchMap(countdown))

  /**
   * MobX-representation the time until expiration stream.
   */
  private readonly _timeUntilExpiration = asAtom(
    this._timeUntilExpiration$,
    null,
  )

  id = Id.none
  @observable accessor workspaceId = Id.none
  @observable accessor primarySoftware = ''
  @observable accessor supplementalSoftware: string | null = null
  @observable accessor location = ''
  @observable accessor description = ''
  @observable accessor specialties: string[] = []
  @observable accessor dateCreated: Date = unixEpoch()
  @observable accessor dateModified: Date = unixEpoch()
  @observable accessor dateInvited: Date = unixEpoch()

  @computed
  get dateExpires() {
    return addDays(this.dateInvited, 1)
  }

  @computed
  get timeUntilExpiration() {
    return this._timeUntilExpiration()
  }
}
